import React from 'react'
import { CartesianGrid, Line, LineChart, Rectangle, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'
import moment from 'moment'
import DynamicTick from '../DynamicTick'

export default function LineChartWidget ({
  lines = [],
  data = [],
  hourly = false,
  xTick = {},
  yTick = {},
  xDataKey = 'date',
  tooltipContent,
  children
}) {
  let tickMode = (hourly)
    ? 'hourly'
    : (
        (data.length <= 20)
          ? 'daily'
          : 'auto'
      )

  let interval = 0

  if (data.length > 20) {
    interval = Math.floor(data.length / 20)
  }

  if (data.length > 61) {
    tickMode = 'monthly-day';
  }

  function CustomDot ({ cy, cx, stroke, payload, value, fill, strokeWidth, ...otherprops }) {
    return (
      <circle cx={cx} cy={cy} r={6} stroke={fill} strokeWidth={1} fill='none'>
        {/* <animate
          attributeName='r'
          from='5'
          to='7'
          dur='1s'
          begin='0s'
          repeatCount='indefinite'
        /> */}
      </circle>
    )
  }

  const CustomCursor = props => {
    const baseX = props.points[0].x
    const width = Math.min(Math.ceil(baseX / (props.payloadIndex + 1)), 50)
    const x = baseX - width / 2

    return (
      <>
        <defs>
          <linearGradient id='chart-cursor-gradient' x1='0%' y1='0%' x2='0%' y2='100%'>
            <stop offset='5%' stopColor='#6D73CC' stopOpacity='0' />
            <stop offset='100%' stopColor='#6D73CC' stopOpacity='0.6' />
          </linearGradient>
        </defs>
        <Rectangle
          fill='url(#chart-cursor-gradient)'
          stroke='none'
          radius={[0, 0, 10, 10]}
          x={x}
          y={0}
          width={width}
          height={props.height + props.bottom + 10}
        />
      </>
    )
  }

  return (
    <ResponsiveContainer>
      <LineChart data={data} margin={{ top: 15, right: 30, bottom: 40, left: 20 }}>
        <CartesianGrid
          vertical={false}
          stroke='#E5E9F1'
        />
        <Tooltip cursor={tickMode !== 'auto' ? <CustomCursor /> : null} content={tooltipContent} />
        <XAxis
          axisLine={false}
          tickLine={false}
          interval={interval}
          scale='time'
          type='number'
          dataKey={xDataKey}
          domain={['auto', 'auto']}
          name='Time'
          tickMargin={25}
          tick={<DynamicTick type='time' mode={tickMode} {...xTick} />}
          tickFormatter={(unixTime) => moment.unix(unixTime).format(hourly ? 'DD/MM HH:mm' : 'DD/MM/YYYY')}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          domain={['auto', 'auto']}
          tick={<DynamicTick type='number' {...yTick} />}
        />
        {lines.map(line => (
          <Line
            strokeWidth={3}
            key={line.dataKey}
            connectNulls
            activeDot={<CustomDot />}
            type='monotone'
            stroke='#8884d8'
            isAnimationActive={false}
            {...line}
          />
        ))}
        {children}
      </LineChart>
    </ResponsiveContainer>
  )
}
